import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { IGetCodes } from 'src/app/interfaces/codes';
import {
  IGetQuestionRelationshipResponse,
  IGroup,
  IQuestionRelationship,
  IQuestionsWithAnswersModifiedResponse,
} from 'src/app/interfaces/questionManagement';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { QuestionManagementService } from 'src/app/Services/question-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-question-relation-modal',
  templateUrl: './question-relation-modal.component.html',
  styleUrls: ['./question-relation-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionRelationModalComponent implements OnInit {
  @Input() SubjectId: number;
  @Input() QuestionId: string | null;
  @Input() ScreenName: string;
  @Input() filter: string = '';
  Questions: IQuestionsWithAnswersModifiedResponse[] = [];
  Relations: IQuestionRelationship[] = [];
  QuestionRelationType: IGetCodes[];
  Groups: IGroup[] = [];
  initialValueGroup: IGroup;
  selectedGroup: IGroup;
  selectedTypeMap: { [key: string]: string } = {};
  relatedQuestions: IGetQuestionRelationshipResponse[];
  path: string;
  constructor(
    public activeModal: NgbActiveModal,
    public questionService: QuestionManagementService,
    private sanitizer: DomSanitizer,
    private readonly toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private modalService: ModalService,
  ) { }

  ngOnInit(): void {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
      QuestionStatusTypeCode: this.filter,
    };
    const getRelatedPayload = {
      ScreenName: 'ADMIN_RELATED_QUESTION',
      SubjectID: this.SubjectId,
      DeletedIND: 'N',
      QuestionID: null,
      RelatedQuestionID: null,
      GroupNumber: null,
      QuestionRelationshipTypeCode: null,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      Screenname: this.ScreenName,
    };
    forkJoin([
      this.questionService.getQuestion$(payloadGetquestions),
      this.questionService.getQuestionRealtionType$({
        Tablename: `QUESTION_RELATIONSHIP_TYPE@ADMIN_RELATED_QUESTIONS`,
      }),
      this.questionService.getRelatedQuestions$(getRelatedPayload),
      this.questionService.getPath$(pathPayload),
    ]).subscribe(
      ([question, questionRealtionType, relatedQuestions, path]) => {
        this.Questions = question;
        this.QuestionRelationType = questionRealtionType;
        this.relatedQuestions = relatedQuestions;
        this.path = path;
        const groups: any[] = this.relatedQuestions.reduce(
          (acc: any[], question) => {
            const groupIndex = acc.findIndex(
              (g) => g.groupNumber === question.Group_Number
            );

            if (groupIndex !== -1) {
              // Add to existing group
              acc[groupIndex].referencingQuestions.push(question);
            } else {
              // Create new group
              acc.push({
                groupNumber: question.Group_Number,
                referencedQuestion: question.Question_ID,
                referencingQuestions: [question],
              });
            }

            return acc;
          },
          []
        );
        if (groups && groups.length) {
          const sorted = groups.sort((a, b) => a.groupNumber - b.groupNumber);
          this.Groups = sorted;
          this.selectedGroup = sorted[0];
          this.initialValueGroup = JSON.parse(JSON.stringify(sorted[0]));
          this.onChangeRelation(sorted[0]);
        }
      },
      (error) => { }
    );
  }

  SanitizeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  AddQuestionRelationGroup() {
    if (this.Groups.length > 0) {
      const LastQuestionGroup = this.Groups[this.Groups.length - 1];
      if (
        LastQuestionGroup.referencedQuestion &&
        LastQuestionGroup.referencingQuestions.length > 0
      ) {
        // this.selectedGroup = LastQuestionGroup;
        // this.initialValueGroup = JSON.parse(JSON.stringify(LastQuestionGroup));
        // this.InsertORUpdateRelatedQuestions();
        this.Groups.push({
          groupNumber: this.Groups.length + 1,
          referencedQuestion: '',
          referencingQuestions: [],
        });
        this.onChangeRelation(this.selectedGroup);
        this.selectedTypeMap = {};
        this.selectedGroup = JSON.parse(
          JSON.stringify(this.Groups[this.Groups.length - 1])
        );
        this.initialValueGroup = JSON.parse(
          JSON.stringify(this.Groups[this.Groups.length - 1])
        );
      } else {
        this.toaster.error(
          'Please select reference question for Group' +
          LastQuestionGroup.groupNumber,
          'Error',
          {
            timeOut: ConstantVars.ToastErrorTimeout,
          }
        );
      }
    } else {
      this.Groups.push({
        groupNumber: this.Groups.length + 1,
        referencedQuestion: '',
        referencingQuestions: [],
      });
      this.selectedGroup = this.Groups[0];
    }
  }

  onDoubleClickTiles(question: IQuestionsWithAnswersModifiedResponse) {
    if (this.selectedGroup && !this.selectedGroup.referencedQuestion) {
      this.selectedGroup.referencedQuestion = question.Question_ID;
    }
    // else if (
    //   this.selectedGroup &&
    //   this.selectedGroup.referencedQuestion !== question.Question_ID
    // ) {
    //   // this.selectedGroup.referencingQuestions.push(question);
    //   this.selectedGroup.referencedQuestion = question.Question_ID;
    // }
  }
  findSelectedTiles(question: IQuestionsWithAnswersModifiedResponse) {
    if (this.selectedGroup && this.selectedGroup.referencingQuestions) {
      return !!this.selectedGroup.referencingQuestions.find(
        (e) =>
          e.Related_Question_ID === question.Question_ID &&
          e.Deleted_IND === 'N'
      );
    } else {
      return false;
    }
  }

  onChangeType(
    event: any,
    question: IQuestionsWithAnswersModifiedResponse
  ): void {
    const type = event.target.value;
    // Update the selectedTypeMap
    this.selectedTypeMap[question.Question_ID] = type;

    // Sync with referencingQuestions in selectedGroup
    const referencingQuestions = this.selectedGroup.referencingQuestions;
    const existingIndex = referencingQuestions.findIndex(
      (q) => q.Related_Question_ID === question.Question_ID
    );

    if (type !== 'null') {
      if (existingIndex === -1) {
        referencingQuestions.push({
          ...question,
          Question_Relationship_Type_Code: type,
          Subject_ID: this.SubjectId,
          Group_Number: this.selectedGroup.groupNumber,
          Related_Question_ID: question.Question_ID,
          Question_Relationship_Type_Name: '',
          Deleted_IND: 'N',
          Updated_By: '',
        });
      } else {
        referencingQuestions[existingIndex].Question_Relationship_Type_Code =
          type;
        referencingQuestions[existingIndex].Deleted_IND = 'N';
      }
    } else {
      if (existingIndex >= 0) {
        // Update existing question to reflect deleted state
        referencingQuestions[existingIndex].Question_Relationship_Type_Code =
          type;
        referencingQuestions[existingIndex].Deleted_IND = 'Y'; // Mark as deleted
      }
    }
  }

  async onChangeRelation(group: IGroup) {
    if (
      this.selectedGroup &&
      !this.hasValueChanged(this.selectedGroup, this.initialValueGroup)
    ) {
      try {
        const result = await this.modalService.open(
          'Confirmation',
          `You have unsaved changes. Do you want to save before leaving?`
        );
        if (result) {
          this.InsertORUpdateRelatedQuestions();

        } else {
          this.Groups[this.selectedGroup.groupNumber - 1] = JSON.parse(
            JSON.stringify(this.initialValueGroup)
          );
        }
      } catch (error) {

      }
      // const confirmSave = confirm('Do you want to save these changes?');
      // if (confirmSave) {
      //   // Save the changes (implement your save logic here)
      //   this.InsertORUpdateRelatedQuestions();
      // } else {
      //   this.Groups[this.selectedGroup.groupNumber - 1] = JSON.parse(
      //     JSON.stringify(this.initialValueGroup)
      //   );
      // }
    }

    this.selectedGroup = group;
    this.initialValueGroup = JSON.parse(JSON.stringify(group));

    // Populate selectedTypeMap for the selected group
    this.selectedTypeMap = {};
    group.referencingQuestions.forEach((q) => {
      this.selectedTypeMap[q.Related_Question_ID] =
        q.Question_Relationship_Type_Code;
    });
  }
  public getClassForQuestion(question: any): any {
    const isSelected =
      this.selectedGroup?.referencedQuestion === question?.Question_ID;
    const isInSelectedTiles = this.findSelectedTiles(question);

    if (isSelected) {
      return {
        'selectedTiles-relation': true, // Always set to true if selected
        'bold-border-relation': true,
        'headertext-color-relation': false,
      };
    } else if (isInSelectedTiles && !isSelected) {
      const refQuestions = this.selectedGroup?.referencingQuestions?.find(
        (e) =>
          e.Related_Question_ID === question.Question_ID &&
          e.Deleted_IND === 'N'
      );

      if (refQuestions) {
        return {
          'primary-relation':
            refQuestions.Question_Relationship_Type_Code === 'Primary',
          'secondary-relation':
            refQuestions.Question_Relationship_Type_Code === 'Secondary',
          'headertext-color-relation': false,
        };
      } else {
        // Ensure ''selectedTiles-relation'' is applied if no refQuestions match
        return {
          'selectedTiles-relation': true,
          'bold-border-relation': true,
          'headertext-color-relation': true,
        };
      }
    }

    // Return an empty object to avoid undefined errors in Angular
    return {};
  }

  public classforCreated(question: any) {
    const isSelected =
      this.selectedGroup?.referencedQuestion === question?.Question_ID;
    const isInSelectedTiles = this.findSelectedTiles(question);

    if (isSelected) {
      return {
        'headertext-color-relation': false,
        'text-white': true,
      };
    } else if (isInSelectedTiles && !isSelected) {
      const refQuestions = this.selectedGroup?.referencingQuestions?.find(
        (e) =>
          e.Related_Question_ID === question.Question_ID &&
          e.Deleted_IND === 'N'
      );

      if (refQuestions) {
        return {
          'text-white': true,
          'headertext-color-relation': false,
        };
      } else {
        // Ensure ''selectedTiles-relation'' is applied if no refQuestions match
        return {
          'headertext-color-relation': true,
        };
      }
    } else {
      return {
        'headertext-color-relation': true,
      };
    }

    // Return an empty object to avoid undefined errors in Angular
    return {};
  }
  private hasValueChanged(group1: IGroup, group2: IGroup): boolean {
    return JSON.stringify(group1) === JSON.stringify(group2);
  }
  InsertORUpdateRelatedQuestions() {
    console.log(this.selectedGroup);

    if (this.selectedGroup.referencingQuestions.length <= 0) {
      this.toaster.error('Select refrence question for selected group before saving', 'Error', {
        timeOut: ConstantVars.ToastErrorTimeout,
      });
      return
    }
    const payload = {
      // QuestionID: this.selectedGroup.referencedQuestion,
      UDTRelatedQuestion: this.selectedGroup.referencingQuestions.map(
        (e, index) => {
          return {
            SubjectID: this.SubjectId,
            GroupNumber: this.selectedGroup.groupNumber,
            QuestionID: this.selectedGroup.referencedQuestion,
            RelatedQuestionID: e.Related_Question_ID,
            QuestionRelationshipTypeCode:
              e.Question_Relationship_Type_Code === 'null'
                ? this.initialValueGroup.referencingQuestions[index]
                  .Question_Relationship_Type_Code
                : e.Question_Relationship_Type_Code,
            DeletedIND: e.Deleted_IND,
            // THIS IS BEEN DONE BECAUSE API DOESNT TAKE NULL AS A VALUE WHEN SENDING DELETE_IND Y THAT WHY WE ARE SENDING PREVIOUS VALUE
          };
        }
      ),
    };
    this.questionService.InsertORUpdateRelatedQuestions$(payload).subscribe(
      (res) => {
        console.log(res);
        this.toaster.success('Saved Successfully', 'Success', {
          timeOut: ConstantVars.ToastSucessTimeout,
        });
        this.initialValueGroup = JSON.parse(JSON.stringify(this.selectedGroup));
        this.afterSave()
      },
      (error) => {
        console.log(error);
        this.toaster.error(error.error.Message, 'Error', {
          timeOut: ConstantVars.ToastErrorTimeout,
        });
      }
    );
  }
  onSave() {
    this.InsertORUpdateRelatedQuestions();
  }
  afterSave() {
    let extra = {
      "groupNumber": 0,
      "referencedQuestion": "",
      "referencingQuestions": []
    }
    let addLast = false

    if (this.Groups[this.Groups.length - 1].referencingQuestions.length <= 0 && this.selectedGroup.groupNumber !== this.Groups[this.Groups.length - 1].groupNumber) {
      extra.groupNumber = this.Groups.length
      addLast = true;
    }
    console.log(extra);


    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
      QuestionStatusTypeCode: this.filter,
    };
    const getRelatedPayload = {
      ScreenName: 'ADMIN_RELATED_QUESTION',
      SubjectID: this.SubjectId,
      DeletedIND: 'N',
      QuestionID: null,
      RelatedQuestionID: null,
      GroupNumber: null,
      QuestionRelationshipTypeCode: null,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      Screenname: this.ScreenName,
    };
    forkJoin([
      this.questionService.getQuestion$(payloadGetquestions),
      this.questionService.getQuestionRealtionType$({
        Tablename: `QUESTION_RELATIONSHIP_TYPE@ADMIN_RELATED_QUESTIONS`,
      }),
      this.questionService.getRelatedQuestions$(getRelatedPayload),
      this.questionService.getPath$(pathPayload),
    ]).subscribe(
      ([question, questionRealtionType, relatedQuestions, path]) => {
        this.Questions = question;
        this.QuestionRelationType = questionRealtionType;
        this.relatedQuestions = relatedQuestions;
        this.path = path;
        const groups: any[] = this.relatedQuestions.reduce(
          (acc: any[], question) => {
            const groupIndex = acc.findIndex(
              (g) => g.groupNumber === question.Group_Number
            );

            if (groupIndex !== -1) {
              // Add to existing group
              acc[groupIndex].referencingQuestions.push(question);
            } else {
              // Create new group
              acc.push({
                groupNumber: question.Group_Number,
                referencedQuestion: question.Question_ID,
                referencingQuestions: [question],
              });
            }

            return acc;
          },
          []
        );
        if (groups && groups.length) {
          const sorted = groups.sort((a, b) => a.groupNumber - b.groupNumber);
          if (addLast) {
            sorted.push(extra)
          }
          this.Groups = sorted;
          this.selectedGroup = sorted[this.selectedGroup.groupNumber - 1];
          this.initialValueGroup = JSON.parse(JSON.stringify(sorted[this.selectedGroup.groupNumber - 1]));
          this.onChangeRelation(sorted[this.selectedGroup.groupNumber - 1]);
        }
      },
      (error) => { }
    );

  }

    printQuestionDetails(question:IQuestionsWithAnswersModifiedResponse) {
    const arr = question.previouslyAppearedDescriptions ;
    const str = arr.join(", ");
    return str ? '('+str+')' :'' ;
  }

  onCross() {
    this.activeModal.close(false);
  }


}
